const PaymentOrderPage = () => import('@/pages/paymentOrder/PaymentOrderPage.vue')

export default {
  path: '/payment_order',
  name: 'PaymentOrderRoute',
  props: (route) => ({ sud: route.query.sud, region: route.query.region }),
  component: PaymentOrderPage
}